import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/alextotalwin/Next Robot AI — Вологда/node_modules/lucide-react/dist/esm/Icon.js");
;
import(/* webpackMode: "eager" */ "/Users/alextotalwin/Next Robot AI — Вологда/node_modules/next/dist/client/app-dir/link.js");
